import React from 'react';
import DesktopComputerIcon from '@heroicons/react/outline/DesktopComputerIcon.js';
import { BlockType } from '../../types/index.js';
import { IframeBlock as Component } from './Block.js';
import { IframeBlockSettings as Settings } from './Settings.js';
export const RegisteredIframeBlock = ({ $t, }) => ({
    recommendedName: 'Iframe',
    Component,
    config: {
        type: BlockType.Block,
        usable: true,
        displayName: $t({
            defaultMessage: 'iFrame',
            id: 'Blocks.IFrame.DisplayName',
        }),
        Settings,
        Icon: React.createElement(DesktopComputerIcon, null),
        defaultProps: { hidden: false },
    },
});
//# sourceMappingURL=registered.js.map